import React, { useMemo } from 'react'
import { getFormattedDate } from '../../../helpers/utils'
import { mergeAssetSummaries } from '../../helpers/mergeAssetSummaries'
import { Table } from 'react-bootstrap'

const CollectionDetailsTab = ({ activity, transactionUuid }) => {
  const mergedAssets = useMemo(() => mergeAssetSummaries(activity), [activity])

  return (
    <div className="container-fluid">
      <div className="row">
        {transactionUuid && (
          <>
            <div className="row show-product-header">
              <div className="col-sm-6">
                <h3 className="margin-text-subtitle">Detalles de reporte:</h3>
              </div>
            </div>
            <hr />
          </>
        )}

        <div>
          <div className="show-product-header-ubiqua-app show-header">
            <div>
              <div className="order-client-name">{activity?.user_full_name}</div>
              <div className="order-client-db_ref">
                Código: {activity?.user_uid}
              </div>
            </div>
          </div>
          <hr />

          <div>
            <table cellSpacing="10">
              <tbody>
                <tr>
                  <td>
                    <div className="mr-85 mb-10">
                      <b>Fecha de solicitud:</b>
                    </div>
                  </td>
                  <td>
                    <div className="mb-10">
                      {getFormattedDate(activity?.asset_collection_report_at) ||
                        '-'}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="mr-85 mb-10">
                      <b>Fecha de aprobación:</b>
                    </div>
                  </td>
                  <td>
                    <div className="mb-10">
                      {getFormattedDate(activity?.supervisor_reviewed_at) || '-'}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="mr-85 mb-10">
                      <b>Número de reporte:</b>
                    </div>
                  </td>
                  <td>
                    <div className="mb-10">{activity?.uid || '-'}</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="mr-85 mb-10">
                      <b>Aprobador por:</b>
                    </div>
                  </td>
                  <td>
                    <div className="mb-10">
                      {activity?.supervisor_reviewed_at
                        ? `${activity?.supervisor_uid || '-'} - ${activity?.supervisor_name || '-'}`
                        : '-'}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />

            <div className="show-data-details">
              <div>
                <b>Activos:</b>
              </div>
            </div>

            <Table hover responsive>
              <thead className="table-header-gray">
                <tr>
                  <th># DE ACTIVO</th>
                  <th>NOMBRE ACTIVO</th>
                  <th>REPORTADO USUARIO</th>
                  <th>REPORTADO SUPERVISOR</th>
                  <th>DIFERENCIA</th>
                </tr>
              </thead>
              <tbody>
                {mergedAssets.length > 0 ? (
                  mergedAssets.map((model, index) => (
                    <tr key={index}>
                      <td>{model.assetUid || '-'}</td>
                      <td>{model.assetTitle || '-'}</td>
                      <td>
                        {model.userTotal != null ? model.userTotal : '-'}
                      </td>
                      <td>
                        {model.supervisorTotal != null
                          ? model.supervisorTotal
                          : '-'}
                      </td>
                      <td>
                        {model.difference != null ? model.difference : '-'}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center">
                      -
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CollectionDetailsTab
